import Footer from "./footer";

type LayoutProps = {
    children: React.ReactNode;
    subdomain: string;
};

const Layout = ({ children }: LayoutProps) => {
    return (
        <>
            <div className="flex flex-col relative min-h-[100dvh]">
                {children}
                <Footer />
            </div>
        </>
    );
};

export default Layout;
